import escapeRegExp from 'lodash-es/escapeRegExp'

import { EMPTY_OBJECT, EMPTY_STRING } from '../constants/common'

/**
 * Build a regex from user query.
 * By default, case-insensitive + unicode-safe ("iu").
 * Use options to control capture/global.
 */
export function createQueryRegex(
  query,
  { capture = false, global = false } = EMPTY_OBJECT
) {
  const trimmedQuery = query?.trim()

  if (!trimmedQuery) {
    return null
  }

  const source = capture
    ? `(${escapeRegExp(trimmedQuery)})`
    : escapeRegExp(trimmedQuery)
  const flags = (global ? 'g' : EMPTY_STRING) + 'iu' // "i" + "u" always; "g" — if needed

  return new RegExp(source, flags)
}

/** For boolean checks (.test), stateless (no "g"). */
export function getMatchRegex(query) {
  return createQueryRegex(query) // → /.../iu
}

/** For split/highlight: keeps matches and finds all (has "g" and capture). */
export function getSplitRegex(query) {
  return createQueryRegex(query, { capture: true, global: true }) // → /(…)/giu
}

// helper: captured groups from .split() appear at odd indexes (1,3,5…)
export function isMatchIndex(index) {
  return index % 2 === 1
}
